import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import { getChartTypeMenuItems } from '../../../../Components/Menu/MenuItemsHelper';
import { CSV, HIGHCHARTS_MENU, PNG, XLS } from '../../../../Utils/Constants';
import applyExporting from 'highcharts/modules/exporting';
import applyOffline from 'highcharts/modules/offline-exporting';
import applyExportData from 'highcharts/modules/export-data';
import Menu from '../../../../Components/Menu/Menu';
import DownloadIcon from '../../../../Components/Buttons/DownloadIcon';
import './AttendanceConversionChart.css';
import {
  DOWNLOAD_CHART,
  MixpanelChartType,
  PNG as mixpanel_PNG,
  CSV as mixpanel_CSV,
  EXCEL as mixpanel_EXCEL,
  VALUE_ADD,
  SESSION_DETAILS
} from '../../../../Telemetry/Mixpanel/Constants/mixpanelConstants';
import {
  trackAnalyticsChartType,
  trackAnalyticsFeature
} from '../../../../Telemetry/Mixpanel/Features/analyticsTracker';

export class AttendanceConversionChart extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };

  static propTypes = {
    reduced_session_details: PropTypes.object,
    user: PropTypes.object
  };
  constructor(props) {
    super(props);
    this.chartRef = createRef();
  }
  componentDidMount() {
    applyExporting(Highcharts);
    applyOffline(Highcharts);
    applyExportData(Highcharts);
  }

  onClickHandler = id => {
    let type = MixpanelChartType.ATTENDANCE_CONVERSION_CHART;
    trackAnalyticsFeature(VALUE_ADD, SESSION_DETAILS, DOWNLOAD_CHART);
    if (id === PNG) {
      this.chartRef.current.chart.exportChart();
      trackAnalyticsChartType(type, mixpanel_PNG);
    } else if (id === XLS) {
      this.chartRef.current.chart.downloadXLS();
      trackAnalyticsChartType(type, mixpanel_EXCEL);
    } else if (id === CSV) {
      this.chartRef.current.chart.downloadCSV();
      trackAnalyticsChartType(type, mixpanel_CSV);
    }
  };

  shouldComponentUpdate(nextProps) {
    const current = this.props.reduced_session_details.sessionDetails;
    const next = nextProps.reduced_session_details.sessionDetails;
    return !Object.is(current, next);
  }

  render() {
    const { sessionDetails, stats } = this.props.reduced_session_details;
    const { t } = this.context;
    const { user } = this.props;

    const detailsMenu = [];
    const menuItems = getChartTypeMenuItems(HIGHCHARTS_MENU);
    menuItems.map(item =>
      detailsMenu.push({
        onClick: () => this.onClickHandler(item.id),
        text: item.title,
        iconClassName: item.iconClass,
        id: item.id
      })
    );

    return (
      <div>
        <div className="attendanceConversionChartLayout">
          <div className="panelHeader">
            <div className="panelTitle">{t('sessionDetails.attendanceConversion')}</div>
            <div>
              <Menu
                menuKey="attendanceConversionChartDownload"
                buttonName={t('buttons.downloadCamelCase')}
                detailsMenu={detailsMenu}
                tooltipText={t('chart.downloadTooltipText')}
                buttonComponent={<DownloadIcon />}
              />
            </div>
          </div>
          <div className="panelBody">
            <HighchartsReact
              ref={this.chartRef}
              highcharts={Highcharts}
              constructorType={'chart'}
              options={this.getChartOptions(sessionDetails, stats, user)}
            />
          </div>
        </div>
      </div>
    );
  }

  getChartOptions = (sessionDetails, stats, user) => {
    const darkMode = user && user.darkMode;
    return {
      colors: ['#0c9ae7'],
      chart: {
        type: 'bar',
        height: 220,
        zoomType: 'x',
        backgroundColor: darkMode ? '#444444' : '#ffffff'
      },
      legend: {
        enabled: false
      },
      title: {
        text: ''
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false,
        csv: {
          decimalPoint: null
        },
        type: 'image/png',
        url: 'https://export.highcharts.com/'
      },
      xAxis: {
        tickWidth: 0,
        lineWidth: 0,
        labels: {
          align: 'left',
          reserveSpace: true,
          color: '#4a4a4a',
          style: {
            fontWeight: 500,
            fontFamily: 'Lato',
            fontSize: '16px',
            color: darkMode ? '#ffffff' : '#666666'
          }
        },
        categories: this.getXAxisCountArray(),
        crosshair: false
      },
      yAxis: [
        {
          gridLineWidth: 0,
          lineWidth: 1,
          min: 0,
          title: '',
          tickAmount: 5,
          allowDecimals: false,
          labels: {
            style: {
              color: darkMode ? '#ffffff' : '#666666'
            }
          }
        }
      ],
      tooltip: { enabled: false },
      plotOptions: {
        series: {
          //minPointLength: 3,
          borderColor: darkMode ? '#444444' : '#ffffff',
          dataLabels: {
            enabled: true,
            color: 'white',
            style: { textOutline: 0 },
            formatter: function() {
              return this.y;
            },
            inside: true,
            align: 'right'
          }
        }
      },
      series: [
        {
          data: this.getSessionDetailsArray(sessionDetails, stats)
        }
      ]
    };
  };

  getSessionDetailsArray = (sessionDetails, stats) => {
    const countArray = [];
    countArray.push({ y: sessionDetails.numRegLinkClicks }, { y: stats.registrants }, { y: stats.attendees });
    return countArray;
  };

  getXAxisCountArray = () => {
    const { t } = this.context;
    return [t('sessionDetails.clickedRegLink'), t('tableTopStat.registrants'), t('tableTopStat.attendees')];
  };
}

export default connect(state => ({
  reduced_session_details: state.reduced_session_details,
  user: state.reduced_user
}))(AttendanceConversionChart);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Chart/AttendanceConversionChart.js